import { z } from 'zod';
import { AiDispositionSchema, AiKindSchema, JobStatusSchema } from './enums.js';

export const AiPromptTemplateSchema = z.object({
  id: z.string(),
  key: z.string(),
  title: z.string(),
  description: z.string(),
  template: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type AiPromptTemplate = z.infer<typeof AiPromptTemplateSchema>;

export const AiJobSchema = z.object({
  id: z.string(),
  orgId: z.string(),
  userId: z.string(),
  assessmentId: z.string().nullable(),
  questionId: z.string().nullable(),
  responseId: z.string().nullable(),
  templateId: z.string().nullable(),
  kind: AiKindSchema,
  inputSummary: z.string(),
  model: z.string(),
  outputContent: z.string().nullable(),
  status: JobStatusSchema,
  disposition: AiDispositionSchema.nullable(),
  error: z.string().nullable(),
  createdAt: z.string(),
  completedAt: z.string().nullable(),
});
export type AiJob = z.infer<typeof AiJobSchema>;

export const GenerateAiInputSchema = z
  .object({
    kind: AiKindSchema,
    responseId: z.string().optional(),
    questionId: z.string().optional(),
    corpusItemId: z.string().optional(),
    /** Extra user instructions appended to the prompt. */
    instructions: z.string().max(4000).optional(),
  })
  .refine((v) => v.responseId || v.questionId || v.corpusItemId, {
    message: 'One of responseId, questionId or corpusItemId is required',
  });
export type GenerateAiInput = z.infer<typeof GenerateAiInputSchema>;

export const AiDispositionInputSchema = z.object({
  disposition: AiDispositionSchema,
});
export type AiDispositionInput = z.infer<typeof AiDispositionInputSchema>;
